import { Tag } from 'components/ReferenceImageGenerator/molecules/ImageGeneratorStage';

export type TrayAction =
  | {
      type: 'REF' | 'NAME';
      payload: string;
    }
  | {
      type: 'NON_STANDARD';
      payload: boolean;
    }
  | {
      type: 'GENERAL_TEST';
      payload: boolean;
    }
  | {
      type: 'IMAGE';
      payload: { referenceTags: Tag[]; originalImage: string; image: string };
    };

/*
 * Tray reducer actions
 */
export const trayActions = {
  // Update tray reference
  ref: (ref: string): TrayAction => ({ type: 'REF', payload: ref }),
  // Update tray image
  image: (image: string, originalImage: string, referenceTags: Tag[]): TrayAction => ({
    type: 'IMAGE',
    payload: { image, originalImage, referenceTags },
  }),
  // Update tray name
  name: (name: string): TrayAction => ({ type: 'NAME', payload: name }),
  // Update tray non standard
  nonStandard: (nonStandard: boolean): TrayAction => ({
    type: 'NON_STANDARD',
    payload: nonStandard,
  }),
  generalTest: (generalTest: boolean): TrayAction => ({
    type: 'GENERAL_TEST',
    payload: generalTest,
  }),
};
